// R6 — sonner loads after first paint. `import { toast } from 'sonner'` resolves here
// (craco alias); calls made before the toaster is mounted are queued and replayed.
const queue = [];
let real = null;
let wake = null;
let seq = 0;

export function toasterReady(t) {
  real = t;
  queue.splice(0).forEach(([m, args]) => (m ? real[m](...args) : real(...args)));
}

export function onToastWanted(fn) {
  wake = fn;
  if (queue.length) fn();
}

// Queued toasts get an id up front so a later toast.success(msg, { id }) still updates them.
const withId = (args) => {
  const [msg, opts] = args;
  if (opts && opts.id != null) return [args, opts.id];
  seq += 1;
  const id = `q${seq}`;
  return [[msg, { ...(opts || {}), id }, ...args.slice(2)], id];
};

const call = (method) => (...args) => {
  if (real) return method ? real[method](...args) : real(...args);
  let ret = args[0];
  let a = args;
  if (method !== 'dismiss' && method !== 'promise') [a, ret] = withId(args);
  queue.push([method, a]);
  if (wake) wake();
  return ret;
};

export const toast = Object.assign(call(null), {
  success: call('success'),
  error: call('error'),
  info: call('info'),
  warning: call('warning'),
  message: call('message'),
  loading: call('loading'),
  dismiss: call('dismiss'),
  promise: call('promise'),
  custom: call('custom'),
});

export default toast;
